export * from './domain';
export * from './builders';
export * from './contact-settings-builder';
export * from './chatbot-poc';
// tslint:disable-next-line:max-line-length
import { WidgetContactType } from './domain';
import { createChatbotPocApi } from './chatbot-poc';
export var createWidgetSettingsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + '/widgets';
    var widgetUrl = function (widgetId) { return apiUrl + "/" + widgetId; };
    var widgetSettingsUrl = function (widgetId) { return apiUrl + "/" + widgetId + "/new-settings"; };
    var widgetContentUrl = function (widgetId, locale) { return widgetSettingsUrl(widgetId) + "/content/" + locale; };
    var featuredArticlesUrl = function (widgetId, locale) { return widgetContentUrl(widgetId, locale) + "/modules/featuredArticles"; };
    var chatModuleUrl = function (widgetId, locale) { return widgetContentUrl(widgetId, locale) + "/contacts/channel/chat"; };
    var contactFormModuleUrl = function (widgetId, locale) { return widgetContentUrl(widgetId, locale) + "/contacts/channel/form"; };
    var phoneModuleUrl = function (widgetId, locale) { return widgetContentUrl(widgetId, locale) + "/contacts/channel/callback"; };
    return {
        getAll: function () { return http.get(apiUrl + "/list"); },
        getAllWidgatsMap: function () { return http.get(apiUrl + "/mapping"); },
        rename: function (dto) { return http.put(widgetUrl(dto.id) + "/rename", { name: dto.name }); },
        delete: function (dto) { return http.delete("" + widgetUrl(dto.id), dto); },
        create: function (dto) { return http.post(apiUrl + "/add", dto); },
        enable: function (dto) { return http.post(widgetSettingsUrl(dto.id) + "/enable", {}); },
        disable: function (dto) { return http.post(widgetSettingsUrl(dto.id) + "/disable", {}); },
        getDesign: function (dto) { return http.get(widgetSettingsUrl(dto.id) + "/appearance"); },
        setDesign: function (dto) { return http.put(widgetSettingsUrl(dto.id) + "/appearance", {
            settings: dto.settings
        }); },
        getAdvanced: function (dto) { return http.get(widgetSettingsUrl(dto.id) + "/advanced"); },
        getCustomText: function (dto) { return http.get(widgetSettingsUrl(dto.id) + "/advanced/" + dto.locale + "/texts"); },
        setCustomText: function (dto) {
            return http.put(widgetSettingsUrl(dto.id) + "/advanced/" + dto.locale + "/texts", { texts: dto.texts });
        },
        getCustomJs: function (dto) { return http.get(widgetSettingsUrl(dto.id) + "/advanced/js"); },
        setCustomJs: function (dto) { return http.put(widgetSettingsUrl(dto.id) + "/advanced/js", { content: dto.content }); },
        getCustomCss: function (dto) { return http.get(widgetSettingsUrl(dto.id) + "/advanced/css"); },
        setCustomCss: function (dto) { return http.put(widgetSettingsUrl(dto.id) + "/advanced/css", { content: dto.content }); },
        setAllowedDomains: function (dto) {
            return http.put(widgetSettingsUrl(dto.id) + "/advanced/domains", { domains: dto.domains });
        },
        setOpeningHours: function (dto) { return http.put(widgetContentUrl(dto.id, dto.locale) + "/contacts/openingHours", dto); },
        setAllContactsOpeningHours: function (dto) {
            return http.put(widgetContentUrl(dto.id, dto.locale) + "/contacts/openingHours/all", dto);
        },
        updateWidgetSchedule: function (dto) { return http.put(widgetContentUrl(dto.id, dto.locale) + "/contacts/schedule", dto); },
        setRequiredAuthenticationEnabled: function (dto) {
            return http.post(widgetSettingsUrl(dto.id) + "/advanced/authenticationEnabled", dto);
        },
        setContentSettings: function (dto) { return http.put("" + widgetContentUrl(dto.id, dto.locale), dto); },
        setCallbackSettings: function (dto) { return http.put("" + phoneModuleUrl(dto.id, dto.locale), dto); },
        setChatSettings: function (dto) { return http.put(widgetContentUrl(dto.id, dto.locale) + "/contacts/channel/chat", {
            settings: dto.settings
        }); },
        setContactFormSettings: function (dto) { return http.put(widgetContentUrl(dto.id, dto.locale) + "/contacts/channel/form", {
            settings: dto.settings
        }); },
        setSearchBarTitle: function (dto) {
            return http.put(widgetContentUrl(dto.id, dto.locale) + "/modules/searchBar/title", { title: dto.title });
        },
        setCategoriesListTitle: function (dto) {
            return http.put(widgetContentUrl(dto.id, dto.locale) + "/modules/categories/title", { title: dto.title });
        },
        setCustomHtmlModuleContent: function (dto) {
            return http.put(widgetContentUrl(dto.id, dto.locale) + "/modules/html/" + dto.moduleId, dto);
        },
        setContentScope: function (dto) {
            return http.put(widgetContentUrl(dto.id, dto.locale) + "/contentScope", {
                contentScope: dto.contentScope, applyToAllLanguages: dto.applyToAllLanguages
            });
        },
        addModule: function (dto) {
            return http.post(widgetSettingsUrl(dto.id) + "/content/" + dto.locale + "/modules", { moduleType: dto.moduleType });
        },
        removeModule: function (dto) {
            return http.delete(widgetSettingsUrl(dto.id) + "/content/" + dto.locale + "/modules/" + dto.moduleId);
        },
        reorderModules: function (dto) {
            return http.put(widgetSettingsUrl(dto.id) + "/content/" + dto.locale + "/modules/reorder", dto);
        },
        enableChatModule: function (dto) {
            return http.post(chatModuleUrl(dto.id, dto.locale) + "/enable", { contactType: WidgetContactType.CHAT });
        },
        disableChatModule: function (dto) {
            return http.post(chatModuleUrl(dto.id, dto.locale) + "/disable", { contactType: WidgetContactType.CHAT });
        },
        enableContactFormModule: function (dto) {
            return http.post(contactFormModuleUrl(dto.id, dto.locale) + "/enable", { contactType: WidgetContactType.CONTACT_FORM });
        },
        disableContactFormModule: function (dto) {
            return http.post(contactFormModuleUrl(dto.id, dto.locale) + "/disable", { contactType: WidgetContactType.CONTACT_FORM });
        },
        enablePhoneModule: function (dto) {
            return http.post(phoneModuleUrl(dto.id, dto.locale) + "/enable", { contactType: WidgetContactType.CALLBACK });
        },
        disablePhoneModule: function (dto) {
            return http.post(phoneModuleUrl(dto.id, dto.locale) + "/disable", { contactType: WidgetContactType.CALLBACK });
        },
        enableLimitContactExposure: function (dto) {
            return http.post(widgetContentUrl(dto.id, dto.locale) + "/contacts/exposure/enable", dto);
        },
        disableLimitContactExposure: function (dto) {
            return http.post(widgetContentUrl(dto.id, dto.locale) + "/contacts/exposure/disable", dto);
        },
        setFeaturedArticleTitle: function (dto) {
            return http.put(featuredArticlesUrl(dto.id, dto.locale) + "/title", dto);
        },
        addFeaturedArticle: function (dto) {
            return http.post("" + featuredArticlesUrl(dto.id, dto.locale), dto);
        },
        removeFeaturedArticle: function (dto) {
            // tslint:disable-next-line:max-line-length
            return http.delete(featuredArticlesUrl(dto.id, dto.locale) + "?locale=" + dto.locale + "&id=" + dto.id + "&articleId=" + dto.articleId);
        },
        reorderFeaturedArticles: function (dto) {
            return http.post(featuredArticlesUrl(dto.id, dto.locale) + "/reorder", dto);
        },
        enableChatContacts: function (dto) {
            var locale = dto.locale;
            var localeParam = '';
            if (locale) {
                localeParam = "?locale=" + dto.locale;
            }
            return http.get(apiUrl + "/enabledChatContacts" + localeParam);
        },
        getTranslations: function (dto) {
            var answersOrigin;
            try {
                var origin_1 = new URL(baseUrl).origin;
                answersOrigin = origin_1;
            }
            catch (_a) {
                answersOrigin = '';
            }
            return http.get(answersOrigin + "/apps/widget/v1/translations/" + dto.locale);
        },
        chatbotPoc: createChatbotPocApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map